import classNames from 'classnames';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { divideNumberPositions } from '../../../service/FormatHelpers/FormatHelpers';
import { TestBem } from '../../../service/TestBem';
import { PhrasesSelectorPhrase, PhrasesSelectorWizardId } from '../../../typings/phrases';
import { Shape2, Shape2Icon } from '../../Shape2/Shape2';
import { PhrasesSelectorRefinePopup } from '../PhrasesSelectorRefinePopup/PhrasesSelectorRefinePopup';

import './PhrasesSelectorKeywordsCell.css';

export interface PhrasesSelectorKeywordsCellProps {
    wizardId: PhrasesSelectorWizardId;
    index: number;
    keyword: PhrasesSelectorPhrase;
    onRemove: (index: number) => void;
    onRefine: (index: number, phrase: PhrasesSelectorPhrase) => void;
    onRefinePopupOpenMetrica: () => void;
}

const BLOCK = 'phrases-selector-keywords-cell';

export class PhrasesSelectorKeywordsCell extends React.PureComponent<PhrasesSelectorKeywordsCellProps> {
    render() {
        const { keyword, wizardId, onRefinePopupOpenMetrica } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                <div className={Bem.cls(BLOCK, 'header')}>
                    <PhrasesSelectorRefinePopup
                        wizardId={wizardId}
                        keyword={keyword}
                        anchorBlockName={BLOCK}
                        onRefine={this.onRefine}
                        onRefinePopupOpenMetrica={onRefinePopupOpenMetrica}
                    />
                </div>
                <span className={Bem.cls(BLOCK, 'shows')}>{divideNumberPositions(keyword.shows)}</span>
                <Button
                    theme="clear"
                    size="s"
                    cls={classNames(Bem.cls(BLOCK, 'icon-button'), TestBem.cls(BLOCK, 'remove-btn'))}
                    onClick={this.onRemove}
                >
                    <Shape2 width={14} height={14} icon={Shape2Icon.trashbin} />
                </Button>
            </div>
        );
    }

    private onRemove = () => {
        const { index, onRemove } = this.props;

        onRemove(index);
    };

    private onRefine = (phrase: PhrasesSelectorPhrase) => {
        const { index, onRefine } = this.props;

        onRefine(index, phrase);
    };
}
